import {GetCharacterInkStore} from '@/graphql/queries/Character.graphql'

export default {
  data(){
    return {
      shouldLoadCharacterInkStore : false,

      inkCountingParams  : {
        textCounting                : 0,
        storedInkCount              : 0,
        unitLabel                   : '染',

        displayStyle                : 'countingWithLimit',
      }
    }
  },

  apollo : {
    characterInkStore : {
      query : GetCharacterInkStore,

      skip(){
        return !this.shouldLoadCharacterInkStore;
      },
      
      fetchPolicy: 'no-cache',
    }
  },

  watch : {
    shouldShowInkCounter : {
      handler(value){
        this.shouldLoadCharacterInkStore = value;
      }
    },

    characterInkStore : {
      handler(data){
        if(typeof data === 'undefined') return;
        if(data === null) return;

        this.inkCountingParams.storedInkCount = data.total_ink_count;
      }
    },

    inputCount : {
      handler(value){
        if(typeof value === 'undefined') return;
        if(value === null) return;

        this.inkCountingParams.textCounting = value;
      },
      immediate: true
    }
  }
}